













































































































































































































import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { useThemeStore } from "@/shared/store/theme";
import { AuthorizedSigner } from "@/shared/types";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
@Component({
  components: {
    Button,
    UsStateSelector
  }
})
export default class EditAuthorizedSigner extends Vue {
  themeStore = useThemeStore();

  isSubmitting = false;

  @Prop({ required: true })
  authorizedSigner: AuthorizedSigner;

  @Prop({ required: true })
  onSave: () => Promise<void>;

  @Prop()
  toggleClose: () => void;

  @Prop()
  isNew: boolean;

  @Prop()
  show: { value: boolean };

  get title () {
    return this.isNew ? "Add Authorized Signer" : "Update Authorized Signer";
  }

  get submitDisabled () {
    return !this.isValid || this.isSubmitting;
  }

  get isValid () {
    return !this.$validator.errors.any();
  }

  save () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isSubmitting = true;

      this.onSave().finally(() => {
        this.isSubmitting = false;
      });
    });
  }
}
